import { gql } from '@apollo/client';

export type GetFarmVariables = {
  poolId: number;
};

// TODO: I likely don't need all these fields
export const getFarmQuery = gql`
  query getFarm($poolId: Int!) {
    getFarm(poolId: $poolId) {
      poolId
      farmPoolId
      farmName
      searchName
      shortLpName
      lpName
      lpAddress
      displayName
      exchange
      isExternal
      isGeneric
      isIchiPool
      isMigrating
      isRetired
      isHidden
      isUpcoming
      isDeposit
      isPosition
      lpPrice
      tvl
      farmTVL
      totalPoolLP
      weeklyAPY
      yearlyAPY
      dailyAPY
      futureAPY
      launchDate
      chainId
      lpDeployer
      strategyBy
      tokens {
        name
        displayName
        address
        decimals
        reserve
        price
        isOneToken
        isBaseToken
      }
      farm {
        farmAddress
        farmId
        farmRewardTokenAddress
        farmRewardTokenDecimals
        farmRewardTokenName
      }
      extras {
        externalText
        externalUrl
        externalButton
        tradeUrl
      }
    }
  }
`;
